import { Box, Button, IconButton, Spacer, useToast } from "@chakra-ui/react";
import { useActiveAccount, useObservableEagerState } from "applesauce-react/hooks";
import { useContext } from "react";

import {
  DirectMessagesIcon,
  GamesIcon,
  MarketsIcon,
  NotesIcon,
  NotificationsIcon,
  SettingsIcon,
  ShareIcon,
  WalletIcon,
} from "../../icons";
import Users02 from "../../icons/users-02";
import { gameNotifications$ } from "../../../services/notifications";
import NavItem from "./nav-item";
import { CollapsedContext } from "../context";

function GamesNavItem() {
  const events = useObservableEagerState(gameNotifications$) ?? [];
  const count = events.length;

  return (
    <Box position="relative">
      <NavItem to="/games" icon={GamesIcon} label="Games" />
      {count > 0 && (
        <Box
          position="absolute"
          top="0"
          right="0"
          w="2.5"
          h="2.5"
          borderRadius="full"
          bg="red.500"
          pointerEvents="none"
        />
      )}
    </Box>
  );
}

function InviteNavItem() {
  const collapsed = useContext(CollapsedContext);
  const toast = useToast();

  const handleInvite = () => {
    const url = `${window.location.origin}/join`;
    if (navigator.share) {
      navigator.share({ url, title: "Join litStrudel" }).catch(() => {});
    } else {
      navigator.clipboard.writeText(url);
      toast({ description: "Invite link copied!", status: "success", duration: 2000 });
    }
  };

  if (collapsed) {
    return (
      <IconButton
        aria-label="Invite"
        title="Invite"
        icon={<ShareIcon boxSize={5} />}
        fontSize="24"
        variant="ghost"
        flexShrink={0}
        onClick={handleInvite}
      />
    );
  }

  return (
    <Button
      aria-label="Invite"
      title="Invite"
      leftIcon={<ShareIcon boxSize={5} />}
      variant="link"
      p="2"
      justifyContent="flex-start"
      flexShrink={0}
      onClick={handleInvite}
    >
      Invite
    </Button>
  );
}

export default function NavItems() {
  const account = useActiveAccount();

  return (
    <>
      <NavItem to="/messages" icon={DirectMessagesIcon} label="Messages" />
      <NavItem to="/feed" icon={NotesIcon} label="Feed" />
      <NavItem to="/communities" icon={Users02} label="Communities" />
      <GamesNavItem />
      <NavItem to="/markets" icon={MarketsIcon} label="Markets" />
      <NavItem to="/notifications" icon={NotificationsIcon} label="Notifications" />
      <NavItem to="/wallet" icon={WalletIcon} label="Wallet" />
      {account && <InviteNavItem />}
      <Spacer />
      <NavItem label="Settings" icon={SettingsIcon} to="/settings" />
    </>
  );
}
